export default __webpack_public_path__ + "static/planeInCloudsMedium-5068d9ef200f1b72c7080215bd494593.png";